module.exports = __webpack_public_path__ + "img/build-to-rent-3.c90792f5.jpg";